/** Medical Reports page strings. */

const mk = (values) => values;

const VITALS_REPORTS_EN = {
  searchVitals: "Search vitals...",
  dateRange: "Date Range",
  today: "Today",
  lastWeek: "Last Week",
  last2Weeks: "Last 2 Weeks",
  customDateRange: "Custom Date Range",
  selectDateRange: "Select date range",
  noVitalsFound: "No Vitals Found",
  errorFetching: "Error fetching data",
  vitalType: "Vital Type",
  dateTime: "Date & Time",
  source: "Source",
  status: "Status",
  notes: "Notes",
  valueBp: "Systolic/Diastolic",
  valueHeart: "BPM",
  valueGlucose: "Glucose mg/dL",
  valueOxygen: "SpO2 (%)",
  valueDefault: "Value",
  vitalsReports: "Vitals Reports",
};

export const VITALS_REPORTS_LOCALE_BLOCKS = {
  hi: mk({
    searchVitals: "वाइटल्स खोजें...",
    dateRange: "तारीख सीमा",
    today: "आज",
    lastWeek: "पिछला सप्ताह",
    last2Weeks: "पिछले 2 सप्ताह",
    customDateRange: "कस्टम तारीख सीमा",
    selectDateRange: "तारीख सीमा चुनें",
    noVitalsFound: "कोई वाइटल नहीं मिला",
    errorFetching: "डेटा लाने में त्रुटि",
    vitalType: "वाइटल प्रकार",
    dateTime: "दिनांक और समय",
    source: "स्रोत",
    status: "स्थिति",
    notes: "नोट्स",
    valueBp: "सिस्टोलिक/डायस्टोलिक",
    valueHeart: "BPM",
    valueGlucose: "ग्लूकोज mg/dL",
    valueOxygen: "SpO2 (%)",
    valueDefault: "मान",
    vitalsReports: "वाइटल्स रिपोर्ट्स",
  }),
  pa: mk({
    searchVitals: "ਵਾਇਟਲ ਖੋਜੋ...",
    dateRange: "ਤਾਰੀਖ ਸੀਮਾ",
    today: "ਅੱਜ",
    lastWeek: "ਪਿਛਲਾ ਹਫ਼ਤਾ",
    last2Weeks: "ਪਿਛਲੇ 2 ਹਫ਼ਤੇ",
    customDateRange: "ਕਸਟਮ ਤਾਰੀਖ ਸੀਮਾ",
    selectDateRange: "ਤਾਰੀਖ ਸੀਮਾ ਚੁਣੋ",
    noVitalsFound: "ਕੋਈ ਵਾਇਟਲ ਨਹੀਂ ਮਿਲਿਆ",
    errorFetching: "ਡੇਟਾ ਲਿਆਉਣ ਵਿੱਚ ਗਲਤੀ",
    vitalType: "ਵਾਇਟਲ ਕਿਸਮ",
    dateTime: "ਤਾਰੀਖ ਅਤੇ ਸਮਾਂ",
    source: "ਸਰੋਤ",
    status: "ਸਥਿਤੀ",
    notes: "ਨੋਟਸ",
    valueBp: "ਸਿਸਟੋਲਿਕ/ਡਾਇਸਟੋਲਿਕ",
    valueHeart: "BPM",
    valueGlucose: "ਗਲੂਕੋਜ਼ mg/dL",
    valueOxygen: "SpO2 (%)",
    valueDefault: "ਮੁੱਲ",
    vitalsReports: "ਵਾਇਟਲ ਰਿਪੋਰਟਾਂ",
  }),
  te: mk({
    searchVitals: "వైటల్స్ వెతకండి...",
    dateRange: "తేదీ పరిధి",
    today: "ఈరోజు",
    lastWeek: "గత వారం",
    last2Weeks: "గత 2 వారాలు",
    customDateRange: "కస్టమ్ తేదీ పరిధి",
    selectDateRange: "తేదీ పరిధి ఎంచుకోండి",
    noVitalsFound: "వైటల్స్ కనుగొనబడలేదు",
    errorFetching: "డేటా తీసుకురావడంలో లోపం",
    vitalType: "వైటల్ రకం",
    dateTime: "తేదీ మరియు సమయం",
    source: "మూలం",
    status: "స్థితి",
    notes: "గమనికలు",
    valueBp: "సిస్టోలిక్/డయాస్టోలిక్",
    valueHeart: "BPM",
    valueGlucose: "గ్లూకోజ్ mg/dL",
    valueOxygen: "SpO2 (%)",
    valueDefault: "విలువ",
    vitalsReports: "వైటల్ రిపోర్ట్లు",
  }),
  ta: mk({
    searchVitals: "வைட்டல்களைத் தேடு...",
    dateRange: "தேதி வரம்பு",
    today: "இன்று",
    lastWeek: "கடந்த வாரம்",
    last2Weeks: "கடந்த 2 வாரங்கள்",
    customDateRange: "தனிப்பயன் தேதி வரம்பு",
    selectDateRange: "தேதி வரம்பைத் தேர்ந்தெடுக்கவும்",
    noVitalsFound: "வைட்டல்கள் இல்லை",
    errorFetching: "தரவைப் பெறுவதில் பிழை",
    vitalType: "வைட்டல் வகை",
    dateTime: "தேதி மற்றும் நேரம்",
    source: "மூலம்",
    status: "நிலை",
    notes: "குறிப்புகள்",
    valueBp: "சிஸ்டாலிக்/டயஸ்டாலிக்",
    valueHeart: "BPM",
    valueGlucose: "குளுக்கோஸ் mg/dL",
    valueOxygen: "SpO2 (%)",
    valueDefault: "மதிப்பு",
    vitalsReports: "வைட்டல் அறிக்கைகள்",
  }),
  mr: mk({
    searchVitals: "व्हायटल्स शोधा...",
    dateRange: "तारीख श्रेणी",
    today: "आज",
    lastWeek: "मागील आठवडा",
    last2Weeks: "मागील 2 आठवडे",
    customDateRange: "सानुकूल तारीख श्रेणी",
    selectDateRange: "तारीख श्रेणी निवडा",
    noVitalsFound: "व्हायटल्स सापडले नाहीत",
    errorFetching: "डेटा आणताना त्रुटी",
    vitalType: "व्हायटल प्रकार",
    dateTime: "तारीख आणि वेळ",
    source: "स्रोत",
    status: "स्थिती",
    notes: "नोट्स",
    valueBp: "सिस्टोलिक/डायस्टोलिक",
    valueHeart: "BPM",
    valueGlucose: "ग्लुकोज mg/dL",
    valueOxygen: "SpO2 (%)",
    valueDefault: "मूल्य",
    vitalsReports: "व्हायटल अहवाल",
  }),
  bn: mk({
    searchVitals: "ভাইটাল খুঁজুন...",
    dateRange: "তারিখের পরিসর",
    today: "আজ",
    lastWeek: "গত সপ্তাহ",
    last2Weeks: "গত ২ সপ্তাহ",
    customDateRange: "কাস্টম তারিখের পরিসর",
    selectDateRange: "তারিখের পরিসর নির্বাচন করুন",
    noVitalsFound: "কোনো ভাইটাল পাওয়া যায়নি",
    errorFetching: "ডেটা আনতে ত্রুটি",
    vitalType: "ভাইটাল ধরন",
    dateTime: "তারিখ ও সময়",
    source: "উৎস",
    status: "অবস্থা",
    notes: "নোট",
    valueBp: "সিস্টোলিক/ডায়াস্টোলিক",
    valueHeart: "BPM",
    valueGlucose: "গ্লুকোজ mg/dL",
    valueOxygen: "SpO2 (%)",
    valueDefault: "মান",
    vitalsReports: "ভাইটাল রিপোর্ট",
  }),
  kn: mk({
    searchVitals: "ವೈಟಲ್‌ಗಳನ್ನು ಹುಡುಕಿ...",
    dateRange: "ದಿನಾಂಕ ಶ್ರೇಣಿ",
    today: "ಇಂದು",
    lastWeek: "ಕಳೆದ ವಾರ",
    last2Weeks: "ಕಳೆದ 2 ವಾರಗಳು",
    customDateRange: "ಕಸ್ಟಮ್ ದಿನಾಂಕ ಶ್ರೇಣಿ",
    selectDateRange: "ದಿನಾಂಕ ಶ್ರೇಣಿ ಆಯ್ಕೆಮಾಡಿ",
    noVitalsFound: "ವೈಟಲ್‌ಗಳು ಕಂಡುಬಂದಿಲ್ಲ",
    errorFetching: "ಡೇಟಾ ತರಲು ದೋಷ",
    vitalType: "ವೈಟಲ್ ಪ್ರಕಾರ",
    dateTime: "ದಿನಾಂಕ ಮತ್ತು ಸಮಯ",
    source: "ಮೂಲ",
    status: "ಸ್ಥಿತಿ",
    notes: "ಟಿಪ್ಪಣಿಗಳು",
    valueBp: "ಸಿಸ್ಟೋಲಿಕ್/ಡಯಾಸ್ಟೋಲಿಕ್",
    valueHeart: "BPM",
    valueGlucose: "ಗ್ಲೂಕೋಸ್ mg/dL",
    valueOxygen: "SpO2 (%)",
    valueDefault: "ಮೌಲ್ಯ",
    vitalsReports: "ವೈಟಲ್ ವರದಿಗಳು",
  }),
};

export const REPORTS_LOCALE_BLOCKS = {
  hi: mk({
    title: "मेडिकल रिपोर्ट्स",
    searchPlaceholder: "नाम से खोजें",
    month: "महीना",
    year: "वर्ष",
    prescriptions: "पर्चे",
    doctorNotes: "डॉक्टर नोट्स",
    labReport: "लैब रिपोर्ट",
    imaging: "इमेजिंग",
    patient: "मरीज़",
    testName: "टेस्ट का नाम",
    doctor: "डॉक्टर",
    dateTime: "दिनांक और समय",
    status: "स्थिति",
    action: "कार्रवाई",
  }),
  pa: mk({
    title: "ਮੈਡੀਕਲ ਰਿਪੋਰਟਾਂ",
    searchPlaceholder: "ਨਾਮ ਨਾਲ ਖੋਜੋ",
    month: "ਮਹੀਨਾ",
    year: "ਸਾਲ",
    prescriptions: "ਪਰਚੇ",
    doctorNotes: "ਡਾਕਟਰ ਨੋਟਸ",
    labReport: "ਲੈਬ ਰਿਪੋਰਟ",
    imaging: "ਇਮੇਜਿੰਗ",
    patient: "ਮਰੀਜ਼",
    testName: "ਟੈਸਟ ਦਾ ਨਾਮ",
    doctor: "ਡਾਕਟਰ",
    dateTime: "ਤਾਰੀਖ ਅਤੇ ਸਮਾਂ",
    status: "ਸਥਿਤੀ",
    action: "ਕਾਰਵਾਈ",
  }),
  te: mk({
    title: "మెడికల్ రిపోర్ట్లు",
    searchPlaceholder: "పేరుతో వెతకండి",
    month: "నెల",
    year: "సంవత్సరం",
    prescriptions: "ప్రిస్క్రిప్షన్లు",
    doctorNotes: "డాక్టర్ నోట్స్",
    labReport: "ల్యాబ్ రిపోర్ట్",
    imaging: "ఇమేజింగ్",
    patient: "రోగి",
    testName: "పరీక్ష పేరు",
    doctor: "డాక్టర్",
    dateTime: "తేదీ మరియు సమయం",
    status: "స్థితి",
    action: "చర్య",
  }),
  ta: mk({
    title: "மருத்துவ அறிக்கைகள்",
    searchPlaceholder: "பெயரால் தேடு",
    month: "மாதம்",
    year: "ஆண்டு",
    prescriptions: "மருந்துச்சீட்டுகள்",
    doctorNotes: "மருத்துவர் குறிப்புகள்",
    labReport: "ஆய்வக அறிக்கை",
    imaging: "இமேஜிங்",
    patient: "நோயாளி",
    testName: "பரிசோதனை பெயர்",
    doctor: "மருத்துவர்",
    dateTime: "தேதி மற்றும் நேரம்",
    status: "நிலை",
    action: "செயல்",
  }),
  mr: mk({
    title: "वैद्यकीय अहवाल",
    searchPlaceholder: "नावाने शोधा",
    month: "महिना",
    year: "वर्ष",
    prescriptions: "प्रिस्क्रिप्शन",
    doctorNotes: "डॉक्टर नोट्स",
    labReport: "लॅब अहवाल",
    imaging: "इमेजिंग",
    patient: "रुग्ण",
    testName: "चाचणीचे नाव",
    doctor: "डॉक्टर",
    dateTime: "तारीख आणि वेळ",
    status: "स्थिती",
    action: "कृती",
  }),
  bn: mk({
    title: "মেডিকেল রিপোর্ট",
    searchPlaceholder: "নামে খুঁজুন",
    month: "মাস",
    year: "বছর",
    prescriptions: "প্রেসক্রিপশন",
    doctorNotes: "ডাক্তার নোট",
    labReport: "ল্যাব রিপোর্ট",
    imaging: "ইমেজিং",
    patient: "রোগী",
    testName: "পরীক্ষার নাম",
    doctor: "ডাক্তার",
    dateTime: "তারিখ ও সময়",
    status: "অবস্থা",
    action: "কর্ম",
  }),
  kn: mk({
    title: "ವೈದ್ಯಕೀಯ ವರದಿಗಳು",
    searchPlaceholder: "ಹೆಸರಿನಿಂದ ಹುಡುಕಿ",
    month: "ತಿಂಗಳು",
    year: "ವರ್ಷ",
    prescriptions: "ಪ್ರಿಸ್ಕ್ರಿಪ್ಷನ್‌ಗಳು",
    doctorNotes: "ವೈದ್ಯರ ಟಿಪ್ಪಣಿಗಳು",
    labReport: "ಲ್ಯಾಬ್ ವರದಿ",
    imaging: "ಇಮೇಜಿಂಗ್",
    patient: "ರೋಗಿ",
    testName: "ಪರೀಕ್ಷೆಯ ಹೆಸರು",
    doctor: "ವೈದ್ಯರು",
    dateTime: "ದಿನಾಂಕ ಮತ್ತು ಸಮಯ",
    status: "ಸ್ಥಿತಿ",
    action: "ಕ್ರಿಯೆ",
  }),
};

export const applyReportsLocaleBlocks = (translations) => {
  if (!translations.en?.reportsPage) {
    translations.en.reportsPage = {
      title: "Medical Reports",
      searchPlaceholder: "Search By Name",
      month: "Month",
      year: "Year",
      prescriptions: "Prescriptions",
      doctorNotes: "Doctor Notes",
      labReport: "Lab Report",
      imaging: "Imaging",
      patient: "Patient",
      testName: "Test Name",
      doctor: "Doctor",
      dateTime: "Date & Time",
      status: "Status",
      action: "Action",
    };
  }
  if (!translations.en?.vitalsReportsPage) {
    translations.en.vitalsReportsPage = VITALS_REPORTS_EN;
  }
  Object.entries(REPORTS_LOCALE_BLOCKS).forEach(([lang, values]) => {
    if (!translations[lang]) return;
    translations[lang].reportsPage = {
      ...translations.en.reportsPage,
      ...translations[lang].reportsPage,
      ...values,
    };
  });
  Object.entries(VITALS_REPORTS_LOCALE_BLOCKS).forEach(([lang, values]) => {
    if (!translations[lang]) return;
    translations[lang].vitalsReportsPage = {
      ...translations.en.vitalsReportsPage,
      ...translations[lang].vitalsReportsPage,
      ...values,
    };
  });
};
